import styles from '../style.module.css';

const SvgFilter = () => {
  return (
    <svg
      className={styles.svgFilter}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <defs>
        <filter id="blurFilter">
          <feGaussianBlur
            id="blurFilterItem"
            in="SourceGraphic"
            stdDeviation="13,0"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SvgFilter;
